import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackCallButtonClick } from './tracking';
import { ChatHeaderCallButton } from '../../components/ChatHeader';
import { userIdSelector, offerSelector } from '../../selectors';
import { formatOfferPhone } from '../../utils/getOfferPhone';

export const ChatHeaderCallButtonContainer: React.FC = () => {
  const [phone, setPhone] = React.useState<string>('');

  const offer = useSelector(offerSelector);
  const userId = useSelector(userIdSelector);

  React.useEffect(() => {
    /* istanbul ignore next */
    if (offer?.phone && offer?.userId !== userId) {
      const phoneString = `tel:${formatOfferPhone(offer.phone)}`;

      setPhone(phoneString);
    }
  }, [offer, userId]);

  const handleClick = () => {
    if (offer) {
      trackCallButtonClick(offer);
    }
  };

  return phone ? <ChatHeaderCallButton phone={phone} onClick={handleClick} /> : null;
};
